import { render, staticRenderFns } from "./emailsList.vue?vue&type=template&id=2bf1d796&scoped=true&lang=pug&"
import script from "./emailsList.vue?vue&type=script&lang=js&"
export * from "./emailsList.vue?vue&type=script&lang=js&"
import style0 from "./emailsList.vue?vue&type=style&index=0&id=2bf1d796&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1d796",
  null
  
)

export default component.exports